<template functional>
  <g
    :ref="data.ref"
    :class="[data.class, data.staticClass]"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    v-on="listeners"
    v-tooltip="props.tooltip"
  >
    <!--this is used for coloring the moe-->
    <rect
      v-if="(props.y[0] - props.y[2]) > 1"
      v-bind:width="props.width"
      v-bind:x="props.x"
      v-bind:y="props.y[2]"
      v-bind:height="props.y[0] - props.y[2]"
      v-bind:fill="`url(#grad${(props.fill || '1').replace(/[(),#\s]+/g, '-')})`"
    ></rect>
    <!--this is used for highlighting the value-->
    <line
      v-if="props.y[0] !== props.y[2]"
      v-bind:x1="props.x"
      v-bind:x2="props.x + props.width"
      v-bind:y1="props.y[1]"
      v-bind:y2="props.y[1]"
      stroke="#D32704"
    ></line>
    <rect
      v-if="(props.y[0] - props.y[2]) > 1 && (props.selected || props.hover)"
      v-bind:class="{ 'selected-bar': props.selected, 'hover-bar': props.hover }"
      v-bind:width="props.width"
      v-bind:x="props.x"
      v-bind:y="props.y[1]"
      v-bind:height="props.height - props.y[1]"
    ></rect>
    <!--this is used for coloring the value-->
    <rect
      v-bind:class="['bar', { 'selected-bar': props.selected, 'hover-bar': props.hover }]"
      v-bind:fill="props.fill || '#6f978d'"
      v-bind:width="props.width"
      v-bind:x="props.x"
      v-bind:y="props.y[0] - (props.clamped ? 12: 0)"
      v-bind:height="props.height - props.y[0] + (props.clamped ? 12: 0)"
    ></rect>
    <!--this is used for hover effects not having gaps between bars-->
    <rect
      v-if="(props.step - props.width) > 0.4"
      v-bind:class="['transparent']"
      v-bind:width="props.step"
      v-bind:x="props.x - ((props.step - props.width) / 2)"
      v-bind:y="props.y[2] - 5 - (props.clamped ? 12: 0)"
      v-bind:height="props.height - props.y[2] + 5 + (props.clamped ? 12: 0)"
    ></rect>
  </g>
</template>
<script>
export default {
  name: 'Bar',
  props: ['height', 'width', 'step', 'x', 'y', 'clamped', 'selected', 'hover', 'fill', 'tooltip'],
}
</script>
<style scoped>
  .transparent {
    opacity: 0;
  }
</style>
